import { useEffect, useState } from "react";
import styles from "./EditCatalog.module.css";
import cross from "../../../images/Popup/Cross.svg";
import Backdrop from "../Dialog/Backdrop";
import Toggle from "../../../utils/Toggle/Toggle";
import { CategorySelector } from "../Dialog/CategorySelector";

const FormFields = [
  {
    title: "Catalogue Name",
    placeholder: "Edit Details",
    type: "text",
    value: "name",
  },
  {
    title: "Brand",
    placeholder: "Edit Details",
    type: "text",
    value: "brand",
  },
  {
    title: "Margin",
    placeholder: "0.0",
    type: "number",
    value: "discount",
  },
  {
    title: "Category",
    placeholder: "Edit Details",
    type: "category",
    value: "category",
  },
  {
    title: "Show",
    type: "toggle",
    value: "show",
  },
];

export const EditCatalog = ({
  show,
  handleCancel,
  handleConfirm,
  initialData,
}) => {
  const [formFields, setFormFields] = useState({
    name: "",
    brand: "",
    discount: 0.0,
    category: "",
    show: false,
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (show && initialData) {
      setFormFields({
        name: initialData.name || "",
        brand: initialData.brand || "",
        discount: initialData.discount || 0.0,
        category: initialData.category?._id || initialData.category || "",
        show:
          initialData.showOnWebsite !== undefined
            ? initialData.showOnWebsite
            : initialData.show || false,
      });
    }
  }, [show, initialData]);

  const handleChange = (field, value) => {
    setFormFields((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formFields.name || formFields.name.trim() === "") {
      newErrors.name = "Catalogue name is required";
    }

    if (!formFields.brand || formFields.brand.trim() === "") {
      newErrors.brand = "Brand is required";
    }

    if (!formFields.category || formFields.category === "") {
      newErrors.category = "Category is required";
    }

    if (
      formFields.discount === "" ||
      formFields.discount < 0 ||
      formFields.discount > 100
    ) {
      newErrors.discount = "Discount must be between 0 and 100";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    setSubmitted(true);

    if (!validateForm()) {
      return;
    }

    if (handleConfirm) {
      handleConfirm(formFields);
    }

    setSubmitted(false);
    setErrors({});
  };

  const onCancel = () => {
    setSubmitted(false);
    setErrors({});
    if (handleCancel) {
      handleCancel();
    }
  };

  return show ? (
    <div>
      <Backdrop show={show} switch={onCancel} />
      <div className={styles.editDialog}>
        <div className={styles.cross}>
          <img src={cross} alt="" onClick={onCancel}></img>
        </div>
        <div className={styles.formContainer}>
          <div className={styles.heading}>Catalogue Information</div>
          {FormFields.map((field) => (
            <Input
              key={field.value}
              title={field.title}
              value={formFields[field.value]}
              onChange={(value) => handleChange(field.value, value)}
              placeholder={field.placeholder}
              type={field.type}
              fieldName={field.value}
              error={errors[field.value]}
              submitted={submitted}
            />
          ))}
          <div className={styles.buttonContainer}>
            <button className={styles.cancelButton} onClick={onCancel}>
              Cancel
            </button>
            <button className={styles.saveButton} onClick={handleSubmit}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

const Input = ({
  title,
  value,
  onChange,
  placeholder,
  type,
  fieldName,
  error,
  submitted,
}) => {
  return (
    <div className={styles.fieldWrapper}>
      <div className={styles.fieldContainer}>
        <div className={styles.field}>{title}:</div>
        {type === "text" || type === "number" ? (
          fieldName === "discount" ? (
            <div className={styles.inputWithSuffix}>
              <input
                className={`${styles.input} ${
                  error && submitted ? styles.inputError : ""
                }`}
                name={fieldName}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                type={type}
              />
              <span className={styles.suffix}>%</span>
            </div>
          ) : (
            <input
              className={`${styles.input} ${
                error && submitted ? styles.inputError : ""
              }`}
              name={fieldName}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder}
              type={type}
            />
          )
        ) : type === "toggle" ? (
          <div className={styles.inputToggle}>
            <div>{value === true ? "True" : "False"}</div>
            <Toggle
              status={value}
              setStatus={(newValue) => onChange(newValue)}
            />
          </div>
        ) : type === "category" ? (
          <CategorySelector
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            fieldName={fieldName}
            error={error}
            submitted={submitted}
            styles={styles}
          />
        ) : null}
      </div>
      {error && submitted && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};
